<template>
  <v-dialog v-model="internalValue" max-width="600">
    <v-card class="" loader-height="2" :loading="loading" :disabled="loading">
      <v-card-text class="primary white--text d-flex align-center py-2 px-4">
        <span class="font-size-md white--text">Activity Log</span>
        <v-spacer />
        <v-btn icon @click="close" class="ml-2 white--text"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-text>
      <v-card-text class="pa-4">
        <template v-if="formattedLogs.length > 0">
          <div v-for="(log, index) in formattedLogs" :key="index">
            <div class="d-flex align-center my-1">
              <v-icon :color="getLogIconColor(log)">{{ getLogIcon(log) }}</v-icon>
              <span class="ml-4">{{ getLogText(log) }}</span>
              <span class="ml-4">{{ formatDate(log.created_at) }}</span>
              <span class="ml-4 font-weight-semibold">By: {{ (log.userid_detail || log.user_detail || {}).name }}</span>
            </div>
            <v-divider></v-divider>
          </div>
        </template>
        <div v-else-if="!loading" class="text-center title pa-5 grey--text">No Activity Log</div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatVarianceActivityLogEntry } from '../utils/activityLogHelpers';

const LEGACY_LOG_ICONS = {
  approve: { icon: 'mdi-check-circle', color: 'success' },
  comment: { icon: 'mdi-plus-circle', color: 'info' },
  reject: { icon: 'mdi-close-circle', color: 'error' },
  data: { icon: 'mdi-cloud-upload-outline', color: 'primary' },
};

export default {
  name: 'ActivityLogDialog',
  props: {
    modelValue: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    activitylogdata: { type: Array, default: () => [] },
    reportingType: { type: String, default: '' },
    activitylogconfig: { type: Object, default: () => ({}) },
  },
  emits: ['update:modelValue'],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    formattedLogs() {
      if (!Array.isArray(this.activitylogdata)) {
        return [];
      }

      return this.activitylogdata.map((log) => formatVarianceActivityLogEntry(log, {
        reportingType: this.reportingType,
        labelsName: this.$nova?.labelsName?.bind(this.$nova),
        identifyAndRemapLabelName: this.$nova?.identifyAndRemapLabelName?.bind(this.$nova),
      }));
    },
  },
  methods: {
    close() {
      this.$emit('update:modelValue', false);
    },
    formatDate(value) {
      return this.$nova.formatDate(new Date(value), 'DD-MMM-YYYY, H:m', '');
    },
    getLogText(log) {
      const configEntry = this.activitylogconfig[log.type] || {};
      return log.text || configEntry.displaytext || log.type;
    },
    getLogIcon(log) {
      const configEntry = this.activitylogconfig[log.type] || LEGACY_LOG_ICONS[log.type] || {};
      return configEntry.icon || 'mdi-history';
    },
    getLogIconColor(log) {
      const configEntry = this.activitylogconfig[log.type] || LEGACY_LOG_ICONS[log.type] || {};
      return configEntry.color || 'grey';
    },
  },
};
</script>
